module.exports = __webpack_public_path__ + "img/entity_04.7074278b.jpg";